import styled from 'styled-components';

import { Button } from '@xing-com/crate-lebenslauf-button';
import { IllustrationSpotError } from '@xing-com/illustrations';
import { spaceL, spaceS, spaceXL } from '@xing-com/tokens';
import { BodyCopy, Headline } from '@xing-com/typography';

export const StyledIllustration = styled(IllustrationSpotError)`
  margin: 0 auto;
  display: block;
`;

export const StyledHeadline = styled(Headline)`
  margin: ${spaceXL} 0 ${spaceS};
  text-align: center;
`;

export const StyledBodyCopy = styled(BodyCopy)`
  margin-bottom: ${spaceL};
  text-align: center;
`;

export const StyledButton = styled(Button)`
  margin: 0 auto;
  display: flex;
`;
